import { FunctionComponent, useEffect } from 'react'
import { useDictationContext } from '../../../core/provider/dictation-context.provider'
import { IconButton, Modal } from '../../shared'
import { GaussIframeProps } from './GaussIframe.model'
import styles from './GaussIframe.module.scss'

export const GaussIframe: FunctionComponent<GaussIframeProps> = ({
  onClose,
  isUnmounting,
  url,
}) => {
  const { hideWidget, showWidget } = useDictationContext()

  useEffect(() => {
    hideWidget()
    return () => showWidget()
  }, [hideWidget, showWidget])

  return (
    <Modal isUnmounting={isUnmounting} onClickOutside={onClose}>
      <div className={styles.container}>
        <div className={styles.backWrapper}>
          <IconButton
            onClick={onClose}
            icon="back"
            theme="light"
            testId="button-exit-gauss-iframe"
          />
          <span className={styles.backReturnText}>Retour</span>
        </div>
        <iframe
          className={styles.iframe}
          title="gauss-iframe"
          src={url}
          referrerPolicy="no-referrer"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        />
      </div>
    </Modal>
  )
}
